import { fetchOverheads } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/dataParsing";
import { initializeOverheadFilters } from "./stateInitializers";
// import { getOverheadsInitialFilters } from "./utils";

function augumentReferenceFilters(translate) {
  let initialFilters = initializeOverheadFilters(translate);
  let reference = initialFilters.filters.find((e) => e.id === "reference");
  let items = reference.items;
  return items;
}

export function hasReferenceFilterChanged(filterAreaState, state, refFilterIndex) {
  let isChanged = filterAreaState[refFilterIndex].value.id !== state.filters[refFilterIndex].value.id;
  return isChanged;
}

export function updateOverheadPageFilters(setFilters, filterAreaState) {
  setFilters((state) => {
    let refFilterIndex = state.filters.findIndex((e) => e.id === "reference");
    let shouldUpdateReferenceFilter = hasReferenceFilterChanged(filterAreaState, state, refFilterIndex);
    if (shouldUpdateReferenceFilter) {
      let newState = { ...state, filters: filterAreaState, newest: false };
      return newState;
    } else {
      let newState = { ...state, filters: filterAreaState, newest: true };
      return newState;
    }
  });
}

export async function updateOverheadPageState(isMasterKeyValid, languageKey, overheadFilters, setOverheadFilters, setOverheadData, translate) {
  const isInitialLoad = overheadFilters.isInitialLoad;
  const requestBody = extractRequestBodyFromFilters(overheadFilters, isInitialLoad);
  let overheadData = await fetchOverheads(languageKey, requestBody, (err) => console.log(err), isMasterKeyValid);
  let { context, reportData } = overheadData.data;
  let submitedFilters = context.filters;
  let nextAvailableFilters = context.nextAvailableFilters;
  if (isInitialLoad) {
    nextAvailableFilters.reference = augumentReferenceFilters(translate);
  }
  let updatedFilters = await updateFilters(overheadFilters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, languageKey);
  setOverheadFilters(updatedFilters);
  setOverheadData(reportData);
}
